import { IBusDangKyXeSaveRequest, IBusHuyDangKyRequest } from '../../models/request/bus/busDangKyXeSaveRequest';
import { IUploadExcelRequest } from '../../models/request/bus/uploadExcelRequest';
import { bus_dangkyxe } from '../../models/response/bus/bus_dangkyxe';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_DANGKYXE_PATH = "bus/dang-ky-xe";

class BusDangKyXeApi extends BaseCRUDApi<bus_dangkyxe> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`co-so/${dm_coso_id}/bus/dang-ky-xe`);
	}
	SelectByIdHocSinh(ts_hocsinh_id: number, nam_hoc: string) {
		return apiClient.get(`hoc-sinh/${ts_hocsinh_id}/nam-hoc/${nam_hoc}/bus/dang-ky-xe`);
	}
	Detail(id: number) {
		return apiClient.get(`${API_BUS_DANGKYXE_PATH}/${id}`);
	}
	Save(request: IBusDangKyXeSaveRequest) {
		return request.id > 0 ? this.Update(request) : this.Insert(request);
	}
	Import(request: IUploadExcelRequest) {
		return apiClient.put(`bus/dang-ky-xe/import`, request);
	}
	ValidateImport(request: IUploadExcelRequest) {
		return apiClient.put(`bus/dang-ky-xe/validate-import`, request);
	}
	UpdateHuyDangKy(request: IBusHuyDangKyRequest) {
		return apiClient.put(`bus/dang-ky-xe/huy-dang-ky`, request);
	}
}
export const busDangKyXeApi = new BusDangKyXeApi(API_BUS_DANGKYXE_PATH);
